const zIndex = {
    POPUP: 9999,
    ContextualBar: 100,
    Toast: 50,
    TootTip: 51,
    TableFixedColumn: 1,
    TableFixedHead: 2,
    TableFixedHeadAndColumn: 3,
    Mask: 200,
    Drawer: 201,
};
export default zIndex;
//# sourceMappingURL=zIndex.js.map